import React, { useState, useEffect } from 'react';
import Button from './Button';


const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement?.scrollHeight - window.innerHeight;
      const progress = (scrollTop / docHeight) * 100;
      setScrollProgress(progress);

      if (scrollTop > 800 && progress < 90) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDemoClick = () => {
    const demoSection = document.getElementById('demo');
    if (demoSection) {
      const offset = 80;
      const elementPosition = demoSection?.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[90] hidden md:block animate-fade-in">
      <Button
        variant="default"
        size="lg"
        onClick={handleDemoClick}
        iconName="Calendar"
        iconPosition="left"
        className="neon-glow-primary shadow-cta"
      >
        Запланировать демо
      </Button>
    </div>
  );
};

export default FloatingCTA;